module.exports = __webpack_public_path__ + "img/card.94c98584.svg";